// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dailog-spacing-none{word-break:break-word}.dailog-spacing-none .el-dialog__body{padding:0}.dailog-spacing-none iframe{border:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
